export const AUTH_MODAL_SHOW = 'AUTH_MODAL_SHOW';
export const AUTH_MODAL_HIDE = 'AUTH_MODAL_HIDE';
export const AUTH_CHECK_USER = 'AUTH_CHECK_USER';
export const AUTH_FLUSH_USER = 'AUTH_FLUSH_USER';
export const AUTH_USER_DETAILS = 'AUTH_USER_DETAILS';
export const PULL_DATA_LOADING = 'PULL_DATA_LOADING';
export const PULL_DATA_ERROR = 'PULL_DATA_ERROR';
export const PULL_DATA_SUCCESS = 'PULL_DATA_SUCCESS';
export const PULL_ARCHIVE_LOADING = 'PULL_ARCHIVE_LOADING';
export const PULL_ARCHIVE_ERROR = 'PULL_ARCHIVE_ERROR';
export const PULL_ARCHIVE_SUCCESS = 'PULL_ARCHIVE_SUCCESS';
export const PULL_DUPLICATE_LOADING = 'PULL_DUPLICATE_LOADING';
export const PULL_DUPLICATE_ERROR = 'PULL_DUPLICATE_ERROR';
export const PULL_DUPLICATE_SUCCESS = 'PULL_DUPLICATE_SUCCESS';
